module.exports = __webpack_public_path__ + "static/media/failedicon.6a76523e.png";